module.exports = __webpack_public_path__ + "static/legends-1-1-49cd104ca4a9274857611070a2ca4a26.jpg";